import { getRequest, postRequest, putRequest, patchRequest } from '@helpers/api';

/**
 * Fetch message attachment details
 * @param {string} attachmentId Attachment ID
 * @returns {Promise<*|Object>}
 */
export const fetchAttachment = attachmentId => getRequest(`messaging/messageFile/${attachmentId}/`);

/**
 * Add thread participants
 * @param payload
 * @param {string} payload.messagingThread - Thread status id
 * @param {Array<string>} payload.participants - Participant list.
 * @returns {Promise<*|Object>}
 */
export const addParticipants = payload =>
  putRequest(`messaging/addParticipantsToMessage/${payload.messagingThread}/`, {
    users: payload.participants,
  });

/**
 * Get users list to send to
 * @param payload
 * @param {string} payload.userContains - Text match
 * @param {string} payload.messageThread - Current message thread. Will filter out users already participating in thread
 * @returns {Promise<*|Object>}
 */
export const getUsersToSendTo = payload =>
  getRequest('messaging/usersToSendTo/', {
    user_contains: payload?.userContains,
    message_thread: payload?.messageThread,
  });

/**
 * Set message status
 * @param {string} messageStatusId Status id for thread
 * @param {MessageStatusApiRequest} payload Request data
 * @returns {Promise<*|Object>}
 */
export const updateStatus = (messageStatusId, payload) =>
  patchRequest(`messaging/messageThreadStatus/${messageStatusId}/`, payload);

/**
 * Get messages
 * @param payload
 * @param {string} [payload.messageThread] - Thread status id
 * @param {string} [payload.savedPeriodId] - Saved filing period id
 * @param {string} [payload.messagingType] - Message type
 * @param {string} [payload.search] - Search term
 * @param {boolean} [payload.status] - Message status
 * @param {boolean} [payload.archived] - Is message archived
 * @param {boolean} [payload.dateFrom] - Date from
 * @param {boolean} [payload.dateTo] - Date to
 * @param {number} [payload.limit] - Pagination limit
 * @param {number} [payload.offset] - Pagination offset
 * @param {Object} options - API options
 * @returns {Promise<*|Object>}
 */
export const getMessages = (payload, options) =>
  getRequest(
    'messaging/message/',
    {
      limit: payload?.limit,
      offset: payload?.offset || 0,
      message_thread: payload?.messageThread,
      saved_filing_period: payload?.savedPeriodId,
      message_type: payload?.messagingType,
      search: payload?.search,
      archived: payload?.archived,
      status: payload?.status,
      date_from: payload?.dateFrom || undefined,
      date_to: payload?.dateTo || undefined,
    },
    options
  );

/**
 * Create message
 * @param payload
 * @returns {Promise<*|Object>}
 */
export const postMessageRequest = payload => postRequest('messaging/message/', payload);
